
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tech-solutions",
      function () {
        return require("private-next-pages/tech-solutions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tech-solutions"])
      });
    }
  